const ONBOARDING_TEMPLATE_PRODUCTS_PAGE_LIMIT = 300;

const parsePositiveId = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return Math.trunc(parsed);
};

export const buildOnboardingTemplateProductItems = ({ products = [], t = (key) => key } = {}) =>
  (Array.isArray(products) ? products : []).reduce((items, product) => {
    const productId = parsePositiveId(product?.id);
    if (!productId) return items;
    const productName = String(product?.name || "").trim() || `#${productId}`;
    const isActive = Number(product?.is_active) === 1 || product?.is_active === true;
    items.push({
      value: productId,
      label: isActive ? productName : `${productName} (${t("ncrm.products.status.inactive")})`,
    });
    return items;
  }, []);

export const fetchOnboardingTemplateProducts = async (fetchPage) => {
  if (typeof fetchPage !== "function") return [];

  const products = [];
  let page = 1;
  let total = null;

  while (true) {
    const data = await fetchPage({ limit: ONBOARDING_TEMPLATE_PRODUCTS_PAGE_LIMIT, page });
    const items = Array.isArray(data?.items) ? data.items : [];
    if (items.length) {
      products.push(...items);
    }
    const reportedTotal = Number(data?.total);
    if (Number.isFinite(reportedTotal) && reportedTotal >= 0) {
      total = reportedTotal;
    }
    if (!items.length) break;
    if (total !== null && products.length >= total) break;
    if (items.length < ONBOARDING_TEMPLATE_PRODUCTS_PAGE_LIMIT) break;
    page += 1;
  }

  return products;
};
